import {mutationTypes} from "@/commons/constants";

export default {
	[mutationTypes.PUB.SET_HTTP_HEADER](state, httpHeader) {
		state.pub.httpHeader = httpHeader
	},
}
